module.exports = __webpack_public_path__ + "montserrat-bold-webfont.01202b67f8f79a2c7c9e.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/assets/fonts/montserrat-bold-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-bold-webfont.woff
// module chunks = main